.wrapper {
  padding-top: calc(var(--mantine-spacing-xl) * 2);
  padding-bottom: calc(var(--mantine-spacing-xl) * 2);
}

.title {
  color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
  /* font-family:
    Greycliff CF,
    var(--mantine-font-family); */

  font-size: rem(44px);
  line-height: 1.2;
  /* font-weight: 900; */
  margin-top: calc(var(--mantine-spacing-xl) * 0.5);
  margin-bottom: calc(var(--mantine-spacing-xl) * 1.5);
  @media (max-width: $mantine-breakpoint-xs) {
    font-size: rem(28px);
  }
}

.item {
  border-radius: var(--mantine-radius-md);
  margin-bottom: var(--mantine-spacing-lg);
  border: rem(1px) solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
}
